module.exports = __webpack_public_path__ + "img/社会综治-综合业务中台软件V2.0.4b18627b.jpg";